// Contenuto informativo trial + Pro Tier — usato da modal e da rilettura.

import { useTranslation } from "react-i18next";

export default function TrialMessagingContent({ variant = "direct", onGoToSubscription, compact = false }) {
  const { t } = useTranslation("trial");
  const isAgency = variant === "agency";
  const pStyle = { margin: "0 0 12px", fontSize: compact ? 14 : 15, lineHeight: 1.65, color: "#374151" };
  const linkStyle = {
    color: "#0A85CF",
    fontWeight: 600,
    textDecoration: "none",
    borderBottom: "1px solid rgba(10,133,207,0.35)",
  };

  return (
    <div>
      <p style={pStyle}>{t("content.p1")}</p>
      <p style={pStyle}>
        {isAgency ? (
          <>
            {t("content.p2AgencyBefore")}
            <strong>{t("content.p2AgencyStrong1")}</strong>
            {t("content.p2AgencyMid")}
            <strong>{t("content.p2AgencyStrong2")}</strong>
            {t("content.p2AgencyMid2")}
            <strong>{t("content.p2AgencyStrong3")}</strong>
            {t("content.p2AgencyAfter")}
          </>
        ) : (
          <>
            {t("content.p2DirectBefore")}
            <strong>{t("content.p2DirectStrong1")}</strong>
            {t("content.p2DirectMid")}
            <strong>{t("content.p2DirectStrong2")}</strong>
            {t("content.p2DirectMid2")}
            <strong>{t("content.p2DirectStrong3")}</strong>
            {t("content.p2DirectAfter")}
          </>
        )}
      </p>
      <p style={{ ...pStyle, marginBottom: compact ? 8 : 12 }}>{t("content.p3")}</p>
      {!isAgency && typeof onGoToSubscription === "function" && (
        <p style={{ ...pStyle, marginBottom: 0 }}>
          <button
            type="button"
            onClick={onGoToSubscription}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              font: "inherit",
              ...linkStyle,
            }}
          >
            {t("content.goSubscription")}
          </button>
          <span style={{ color: "#6b7280", fontWeight: 400 }}>{t("content.compareHint")}</span>
        </p>
      )}
      {isAgency && (
        <p style={{ ...pStyle, marginBottom: 0, color: "#6b7280", fontSize: 14 }}>{t("content.agencyManaged")}</p>
      )}
    </div>
  );
}
